/**
 * DataTable Quasar Component
 * q-Btn
 *
 * @since 2018-03-22
 * @author kdydesign.kim
 */

import Vue from 'vue'

export function qBtn ({data, methods, templateName, treeNode}) {
  const vm = new Vue({
    el: `[vue-quasar-template="${templateName}"]`,
    data: {
      authDisable: data.authDisable,
      authForce: data.authForce === true ? data.authForce : false,
      size: data.size || 'md',
      icon: data.icon,
      toolTip: data.toolTip,
      flat: data.flat,
      label: data.label,
      color: data.color || 'primary',
      round: data.round,
      dense: data.dense,
      outline: data.outline,
      align: data.align || 'right',
      disabled: data.disabled === true ? data.disabled : false,
      class: data.class || 'bs bs-q-btn-md',
      iconClass: data.iconClass,
      labelClass: data.labelClass // TAMS
    },
    methods: methods,
    computed: {
      chgDis () {
        if (this.authForce === false && this.authDisable) return true
        return this.disabled
      }
    },
    render (h) {
      const slotRender = []

      if (this.icon || this.iconClass) {
        slotRender.push(
          h('q-icon', { class: ['bs-q-btn-icon', this.iconClass] })
        )
      }

      // TAMS
      if (this.label) {
        let attr = {}
        if (this.labelClass) attr = { 'class': this.labelClass }
        slotRender.push(h('span', attr, this.label))
      }

      if (this.toolTip) {
        let msg = void 0

        if (typeof this.toolTip === 'function') {
          msg = this.toolTip(treeNode)
        } else {
          msg = this.toolTip
        }

        slotRender.push(
          h('q-tooltip', {
            'class': 'bs bs-q-tooltip bs-q-tooltip-default',
            props: {
              anchor: 'top middle',
              self: 'bottom middle',
              offset: [10, 10],
              delay: 500
            }
          }, [ h('span', msg) ])
        )
      }

      return h('q-btn', {
        'class': this.class,
        style: { float: this.align + '!important' },
        attrs: { disabled: this.chgDis },
        props: {
          authForce: this.authForce,
          size: this.size,
          icon: this.icon,
          flat: this.flat,
          color: this.color,
          round: this.round,
          dense: this.dense,
          outline: this.outline
        },
        on: {
          click: (event) => {
            if (this.disabled) return
            const data = { item: treeNode, event: event }
            this.click(data)
            event.stopPropagation()
          }
        }
      },
      slotRender
      )
    }
  })
  return vm
}

export default qBtn
